<div class="g-recaptcha" [attr.data-sitekey]="siteKey" data-callback="reCaptchaVerifyCallback" [attr.data-size]="size"></div>


// WEBPACK FOOTER //
// ./src/app/common-theme/re-captcha.component.ts.ReCaptchaComponent.html